import React from 'react'
import styled from 'styled-components'

import { ReactComponent as ErrorIcon } from '@/assets/svgs/alert-house-plant.svg'
import { ReactComponent as SuccessIcon } from '@/assets/svgs/green-house-checkmark-toggle.svg'
import {
  AssistanceSection,
  InformationSection,
  InformationSectionTitle,
  Layout,
} from '@/components'
import type { RoutesType } from '@/routes/routes'
import { ROUTES } from '@/routes/routes'
import { theme } from '@/theme'
import { Button } from '@/UIkit/Button'
import { Spinner } from '@/UIkit/Spinner'

import { useMFA } from './hooks'

export const LoadingSpinner = styled(Spinner)`
  margin-bottom: 20px;
`

const LogInButton = styled(Button)`
  margin-top: 24px;
  padding-top: 17px;
  padding-bottom: 17px;
`

export const MFAApp = ({
  forceRoute,
}: {
  forceRoute: (route: RoutesType) => void
}) => {
  const { state, error } = useMFA()

  let content = null
  if (state === 'loading') {
    content = (
      <InformationSection>
        <LoadingSpinner size={32} color={theme.colors.primaryDefault} />
        <InformationSectionTitle>Logging in...</InformationSectionTitle>
        Please wait while we verify your details.
      </InformationSection>
    )
  } else if (state === 'error') {
    content = (
      <InformationSection
        title={`We couldn’t verify your request (Error ${error?.code})`}
        iconProps={{ iconComponent: ErrorIcon, width: 175, height: 150 }}
      >
        <div>
          The verification email may have expired or already been used. Please
          try logging in again.
        </div>
        <LogInButton
          mode="primary"
          isFullWidth
          onClick={() => forceRoute(ROUTES.LOGIN)}
        >
          Log in
        </LogInButton>
      </InformationSection>
    )
  } else {
    content = (
      <InformationSection
        title="You're now securely logged in"
        iconProps={{ iconComponent: SuccessIcon, width: 175, height: 150 }}
      >
        Return to your accommodation options email and open the AltoVita add-in
        to approve and submit options.
      </InformationSection>
    )
  }
  return (
    <Layout largeLogo>
      {content}
      <AssistanceSection />
    </Layout>
  )
}
